const cartActionTypes = {
  ADD_TO_CART: "ADD_TO_CART",
  FETCH_CART_ITEMS: "FETCH_CART_ITEMS",
  CLEAR_ITEM: "CLEAR_ITEM",
};

export default cartActionTypes;
